import { render, staticRenderFns } from "./_base.vue?vue&type=template&id=3335a664&scoped=true"
import script from "./_base.vue?vue&type=script&lang=js"
export * from "./_base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3335a664",
  null
  
)

export default component.exports